import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

export const getBirthProcessList = createAsyncThunk(
  "birthProcess/getAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get("/api/sif/potekKotitve");
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getBirthProcessBySifra = createAsyncThunk(
  "birthProcess/getBySifra",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`/api/sif/potekKotitve/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const saveBirthProcess = createAsyncThunk(
  "birthProcess/save",
  async (dto, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.post("/api/sif/potekKotitve", dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateBirthProcess = createAsyncThunk(
  "birthProcess/update",
  async ({ sifra, dto }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.put(
        `/api/sif/potekKotitve/${sifra}`,
        dto
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deleteBirthProcess = createAsyncThunk(
  "birthProcess/delete",
  async ({ sifra, version }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const url = `/api/sif/potekKotitve/${sifra}?version=${version}`;
      const response = await ApiClient.delete(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getBirthProcessPage = createAsyncThunk(
  "birthProcess/getPage",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        "/api/sif/potekKotitve/page",
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const birthProcessSlice = createSlice({
  name: "birthProcessCodeMap",
  initialState: {
    list: [],
    current: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get all
      .addCase(getBirthProcessList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getBirthProcessList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getBirthProcessList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Get by sifra
      .addCase(getBirthProcessBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(getBirthProcessBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getBirthProcessBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Save
      .addCase(saveBirthProcess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(saveBirthProcess.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(saveBirthProcess.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Update
      .addCase(updateBirthProcess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(updateBirthProcess.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateBirthProcess.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Delete
      .addCase(deleteBirthProcess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(deleteBirthProcess.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteBirthProcess.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Get page
      .addCase(getBirthProcessPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getBirthProcessPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getBirthProcessPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default birthProcessSlice.reducer;
